import { formatPhoneNumber } from "react-phone-number-input";

import OnboardingIconContainer from "@/ui/components/onboarding/OnboardingIconContainer";
import { FAIconName, Text, TextTag } from "@/ui/core";
import { Box, HStack, VStack } from "@/ui/layout";
import { joinTestIDs } from "@/utils/string.util";

interface ProviderOverviewProps extends ViewWithTestID {
  email?: string;
  fullName: string;
  isReferring?: boolean;
  phoneNumber?: string;
  practiceLocation?: string;
  specialty?: string;
}

const ProviderOverview = ({
  email,
  fullName,
  isReferring,
  phoneNumber,
  practiceLocation,
  specialty,
  testID,
}: ProviderOverviewProps) => {
  const baseTestID = joinTestIDs(testID, "provider-overview");
  const formattedPhoneNumber =
    (phoneNumber && formatPhoneNumber(phoneNumber)) || phoneNumber;

  const optionalFields = [
    { testID: "specialty", value: specialty },
    { testID: "practice-location", value: practiceLocation },
    { testID: "phone-number", value: formattedPhoneNumber },
    { testID: "email", value: email },
  ].filter((field) => field.value);

  return (
    <HStack gap={12} testID={baseTestID}>
      <OnboardingIconContainer
        iconName={FAIconName.UserDoctor}
        testID={baseTestID}
      />
      <VStack gap={2}>
        <HStack alignItems="center" gap={6}>
          <Text
            testID={joinTestIDs(baseTestID, "full-name")}
            variant="bodyMedium"
          >
            {fullName}
          </Text>
          {isReferring && (
            <Box>
              <TextTag
                testID={joinTestIDs(baseTestID, "referring")}
                text="Referring"
                variant="personInfo"
              />
            </Box>
          )}
        </HStack>
        {optionalFields.map((field) => (
          <Text
            key={field.testID}
            testID={joinTestIDs(baseTestID, field.testID)}
            variant="caption"
          >
            {field.value}
          </Text>
        ))}
      </VStack>
    </HStack>
  );
};

export type { ProviderOverviewProps };
export default ProviderOverview;
